export const testimonials = [
  {
    id: 1,
    name: "Margaret T.",
    role: "Patient & Church Member",
    text: "Dr. Sheldon Mckenzie changed my life. After years of struggling with thyroid issues, his holistic approach — combining medical expertise with spiritual guidance — gave me hope and real results. I feel like a new person.",
    rating: 5,
    avatar: "https://public.readdy.ai/ai/img_res/1a9f01a098b55ffd32eb71d19af0c85e.jpg",
  },
  {
    id: 2,
    name: "James R.",
    role: "Diabetes Patient",
    text: "I was diagnosed with Type 2 diabetes and felt lost. Dr. Sheldon Mckenzie not only helped me manage my condition medically but also walked me through it spiritually. His care is unlike anything I've experienced.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20middle-aged%20man%20smiling%2C%20soft%20neutral%20background%2C%20natural%20lighting%2C%20portrait%20photography&width=80&height=80&seq=avatar2&orientation=squarish",
  },
  {
    id: 3,
    name: "Sandra K.",
    role: "Ministry Member",
    text: "Pastor Mckenzie's's sermons on health and faith opened my eyes. His ministry is a blessing to our community. The online resources have helped my entire family grow spiritually and physically.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20in%20her%2040s%20smiling%20warmly%2C%20soft%20background%2C%20natural%20lighting%2C%20portrait%20photography&width=80&height=80&seq=avatar3&orientation=squarish",
  },
  {
    id: 4,
    name: "David M.",
    role: "Telehealth Patient",
    text: "The virtual consultation was seamless and incredibly thorough. Dr. Sheldon Mckenzie took time to explain everything and even prayed with me at the end. That meant the world to me.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20smiling%2C%20soft%20neutral%20background%2C%20natural%20lighting%2C%20portrait%20photography&width=80&height=80&seq=avatar4&orientation=squarish",
  },
];
